import React from 'react';

const Messages = () => {
    return(<h1>Hello, it's Messages page!</h1>);
};

export default Messages;